import { render } from "./GuiClientDocumentGroupSelect.vue?vue&type=template&id=2f5a1576"
import script from "./GuiClientDocumentGroupSelect.vue?vue&type=script&lang=js"
export * from "./GuiClientDocumentGroupSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__